/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";
import { useTheme } from "@mui/material";

// Components
import Box from "components/Atoms/Box";

// Styles
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

function DataTableBodyCell({ noBorder, align, children, ...rest }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { size } = typography;
  const { borderWidth } = borders;

  // Theme-aware border color
  const borderColor = isDark ? "rgba(255, 255, 255, 0.12)" : theme.palette.grey[300];

  return (
    <Box
      component="td"
      textAlign={align}
      fontSize={size.sm}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${borderColor}`}
      py={1.5}
      px={3}
      {...rest}
    >
      <Box
        display="inline-block"
        width="max-content"
        color="text"
        customClass="vertical-middle"
        sx={{
          color: isDark ? theme.palette.text.primary : "inherit",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
